<template>
    <div>
        <card-header title="Session Tracks" icon="fa-code-branch"></card-header>

        <card-toolbar>
            <button @click="$openCard('conf-new-track', {confId: props.confId}, card)"><i class="far fa-plus"></i>New Session Track</button>
        </card-toolbar>

        <card-body>
            <card-list>
                <conf-track-tile
                    :card="card"
                    :track="track"
                    v-for="track in tracks"
                    :active="(child && child.definition.component === 'conf-edit-track' && track.id === parseInt(child.props.trackId))"
                    @click="$openCard('conf-edit-track', {confId: track.conference_id, trackId: track.id}, card)"
                />
            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";

    import {client as http} from '@/http_client';
    import CardToolbar from "../../../../TIER/components/CardToolbar";
    import ConfSessionTile from "../../../../components/tiles/ConfSessionTile";
    import ConfTrackTile from "../../../../components/tiles/ConfTrackTile";

    export default {
        components: {ConfTrackTile, ConfSessionTile, CardToolbar, CardList, CardHeader, CardBody},
        props: ['card', 'props', 'child'],
        data() {
            return {
                tracks: {}
            };
        },
        methods: {
            loadTracks: function(force) {
                this.$emit('loading', true);
                http.get('conferences/' + this.props.confId + '/tracks', {force}).then(response => {
                    this.tracks = response.data;
                    this.$emit('loading', false);
                }).catch(err => {

                });
            },
            reload: function() {
                this.loadTracks(true);
            }
        },
        mounted() {
            this.loadTracks();
        }
    };
</script>

<style>

</style>
